import React, { useEffect, useState, useRef } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

import Mosque from '../assets/0896027de6ec90b19f912c86796c8f79.jpg';
import compass from '../assets/compass-icon-vector-compass-icon-compass-symbol_118339-4170.jpg';
import PrayerTime from '../assets/download (2).png';

const LandingPagePrayes = ({ scrollY }) => {
  const [inView, setInView] = useState(false);
  const sectionRef = useRef(null);

  // Intersection observer to trigger animations
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        setInView(entry.isIntersecting);
      },
      { threshold: 0.5 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  const items = [
    { title: 'مساجد', image: Mosque, link: '/Mosques' },
    { title: 'القبلة', image: compass, link: '/KiblaCompass' },
    { title: 'مواقيت الصلاة', image: PrayerTime, link: '/PrayerTimePage' },
  ];

  return (
    <div className="w-full flex flex-col justify-center items-center gap-8 py-10">
      {/* Title Section */}
      <motion.h1
        className="text-7xl sm:text-4xl lg:text-7xl text-center my-10 text-gray-800 font-bold"
        style={{fontFamily:'Reem Kufi'}}
        initial={{ opacity: 0, y: -50 }}
        animate={{
          opacity: scrollY > 500 ? 1 : scrollY > 200 ? scrollY / 500 : 0,
          y: scrollY > 500 ? 0 : -50,
        }}
        transition={{
          delay: 0.9,
          type: 'spring',
          stiffness: 50,
        }}
      >
        عبادات
      </motion.h1>

      {/* Cards Section */}
      <div className="w-full flex flex-wrap justify-center gap-6 px-4">
        {items.map((item, index) => (
          <motion.div
            key={index}
            className="bg-white p-6 rounded-lg w-64 sm:w-72 md:w-80 flex justify-center items-center flex-col hover:scale-105 hover:shadow-xl transition-all duration-300"
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: inView ? 1 : 0, y: inView ? 0 : 50 }}
            transition={{ duration: 0.5, type: 'spring', stiffness: 50 }}
            ref={sectionRef}
          >
            <Link to={item.link} className="flex justify-center items-center flex-col text-center">
              <img src={item.image} alt={item.title} className="w-20 sm:w-24 h-20 sm:h-24 object-cover mb-4 rounded-full shadow-md" />
              <span className="text-lg sm:text-xl font-semibold text-gray-800">{item.title}</span>
            </Link>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default LandingPagePrayes;
